import Paragraph from 'components/Typography/Paragraph';
import WrapperBox from 'components/WrapperBox';
import coin from 'assets/icons/coins/coin.png';
import {
  ChallengeCardContainer,
  ChallengeCardContent,
  ChallengeCardCoin,
  ChallengeCardImageCoin,
  ChallengeCardContentTitle,
  ChallengeCardContentInfo,
  ChallengeCardImageContainer,
} from './ChallengeCard.styles';
import { ChallengeCardProps } from './ChallengeCard.types';
import Title from 'components/Typography/Title';
import Label from 'components/Typography/Label';
import {
  getImageShapeByVariant,
  getRandomImageShape,
} from './ChallengeCard.Helper';
import { handleCoins } from 'helpers/MissionsHelper';

const ChallengeCard = ({
  width = '15.813rem',
  height = '8.75rem',
  borderRadius = '0.875rem',
  shadowColor = '#007AD1',
  title,
  imageSrc,
  coins,
  distance,
  mode,
  variant,
  ...rest
}: ChallengeCardProps): JSX.Element => {
  return (
    <WrapperBox
      width={width}
      height={height}
      shadowColor={shadowColor}
      clickable
      {...rest}
    >
      <ChallengeCardContainer>
        <ChallengeCardImageContainer data-testid="image">
          {getImageShapeByVariant({ variant: getRandomImageShape(), imageSrc })}
        </ChallengeCardImageContainer>
        <ChallengeCardContent>
          <ChallengeCardCoin>
            <Paragraph>{handleCoins(+coins)}</Paragraph>
            <ChallengeCardImageCoin src={coin} />
          </ChallengeCardCoin>
          <ChallengeCardContentTitle>
            <Title level={3} renderAs="h3">
              {title}
            </Title>
            <ChallengeCardContentInfo>
              <Label>{distance}</Label>
              <Label>.</Label>
              <Label>{mode}</Label>
            </ChallengeCardContentInfo>
          </ChallengeCardContentTitle>
        </ChallengeCardContent>
      </ChallengeCardContainer>
    </WrapperBox>
  );
};

export default ChallengeCard;
